import React from 'react';
import { ButtonWithText } from '../../atoms/Buttons/ButtonWithText';
import useStyle from './errorLayout.style';
import { refreshPage } from 'helpers/page/refreshPage';

export const ErrorLayout = () => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <h2>
        Une erreur est survenue{' '}
        <span role="img" aria-label="oups">
          😕
        </span>
      </h2>
      <ButtonWithText
        content="Recharger la page"
        onClick={refreshPage}
        icon={'Refresh'}
      />
    </div>
  );
};
